import TimeErrorModal from 'components/summary/TimeErrorModal/styled';

export default TimeErrorModal;
